import Tabs from './component';
import { TabsProps } from './types';

export default Tabs;
export type { TabsProps };
